<div class="header-div">
  <div class="row w-100">
    <div class="col-md-11 d-flex flex-column justify-content-center">
      <button class="btn-transparent-outlined-white mx-auto" (click)="onUserClick('load_recorded_scripts')"> Load Recorded Activities </button>
    </div>
    <div class="col-md-1 row">
      <div class="v-center col-md-6">
        <mat-icon [matMenuTriggerFor]="menu">save</mat-icon>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onUserClick('playwright')">Playwright</button>
          <button mat-menu-item (click)="onUserClick('selenium-java')">Selenium-Java</button>
          <button mat-menu-item (click)="onUserClick('selenium-python')">Selenium-Python</button>
        </mat-menu>
      </div>
      <div class="v-center col-md-6">
        <mat-icon (click)="onUserClick('delete')" (keydown)="onUserClick('delete')">delete_outline</mat-icon>
      </div>
    </div>
  </div>
</div>

<!-- <div class="header-div">
  <div class="col-md-6 d-flex justify-content-between align-items-center">
    <div>
      <img [src]="data.titleImgUrl ? data.titleImgUrl : '../../../../assets/images/connection.png'" alt="Icon" /> <span>{{ data.title? data.title : "Data Connection" }}</span>
    </div>
    <button class="custom-button" (click)="onUserClick('load_recorded_scripts')">
      {{ data.buttonLabel ? data.buttonLabel : "Load Recorded Scripts" }}
    </button>
  </div>

  <div class="col-md-6 d-flex align-items-center flex-row justify-content-end">
    <div
      class="col-md-3 d-flex flex-row align-items-center justify-content-evenly"
    >
      <mat-icon (click)="onUserClick('save')">save</mat-icon>
      <mat-icon (click)="onUserClick('refresh')">refresh</mat-icon>
    </div>

    <div
      class="col-md-2 d-flex flex-row align-items-center justify-content-evenly"
    >
      <mat-icon (click)="onUserClick('collapse')">expand_less</mat-icon>
      <mat-icon (click)="onUserClick('expand')">expand_more</mat-icon>
    </div>

    <div
      class="col-md-3 d-flex flex-row align-items-center justify-content-evenly"
    >
      <mat-icon (click)="onUserClick('copy')">content_copy</mat-icon>
      <mat-icon (click)="onUserClick('paste')">content_paste</mat-icon>
      <mat-icon (click)="onUserClick('delete')">delete_outline</mat-icon>
    </div>
  </div>
</div> -->
